import { gql } from '@apollo/client';

export const UPDATE_NEWS_IMAGE_MUTATION = gql`
  mutation updateNewsImage($input: NewsInput!, $file: Upload) {
    updateNewsImage(input: $input, file: $file) {
      id
    }
  }
`;
